import { render, staticRenderFns } from "./MaTestModal__Style#Drawer.vue?vue&type=template&id=d64705a0&scoped=true"
import script from "./MaTestModal__Style#Drawer.vue?vue&type=script&lang=js"
export * from "./MaTestModal__Style#Drawer.vue?vue&type=script&lang=js"
import style0 from "./MaTestModal__Style#Drawer.vue?vue&type=style&index=0&id=d64705a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64705a0",
  null
  
)

export default component.exports